<template>
    <div class="bg-white m-auto rounded-t-xl shadow-xl mt-5">

        <h2 class="text-2xl font-bold indent-4">seataxi.online</h2>

    </div>

</template>

<script>

</script>

<style scoped></style>